import type { JSX } from 'react';
import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useBetween } from '../../../shared/use-between/use-between';
import { ProductFiltersUseBetween } from '../use-between/product-filters-use-between';
import { IDiameterCheckboxDropdown } from '../interfaces/diameter-checkbox-dropdown.interface';
import { returnSelectedItems } from '../dropdow-list/diameter-checkbox.service';

export interface IDiameterFilterSlider {}

const DiameterFilterSlider: React.FC<IDiameterFilterSlider> = (): JSX.Element => {
    const { diameterMin } = useBetween(ProductFiltersUseBetween);
    const { diameterMax } = useBetween(ProductFiltersUseBetween);
    const { diameterRangeFromTo, setDiameterRangeFromTo } = useBetween(ProductFiltersUseBetween);
    const { diameterList } = useBetween(ProductFiltersUseBetween);
    const { setSelectedNpsAndDnDiameter } = useBetween(ProductFiltersUseBetween);

    const handleChange = (event: Event, newValue: number | number[]) => {
        setDiameterRangeFromTo(newValue as number[]);
    };

    const handleChangeCommited = (event: React.SyntheticEvent | Event, newValue: number | number[]) => {
        const from: number = diameterRangeFromTo[0];
        const to: number = diameterRangeFromTo[1];
        const newSelectedNpsAndDn: IDiameterCheckboxDropdown[] = [];
        const lastDiameter: IDiameterCheckboxDropdown = diameterList[diameterList.length - 1];
        if (from < lastDiameter.config.value) {
            diameterList.forEach((item) => {
                if (item.config.value >= from && item.config.value <= to) {
                    newSelectedNpsAndDn.push(item);
                }
            });
        } else {
            newSelectedNpsAndDn.push(lastDiameter);
        }
        setSelectedNpsAndDnDiameter(returnSelectedItems(newSelectedNpsAndDn));
    };

    return (
        <Box
            sx={{
                width: 300,
                height: 66,
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                paddingLeft: '10px !important',
                paddingBottom: '19px !important',
            }}
        >
            <Slider
                value={diameterRangeFromTo}
                onChange={handleChange}
                onChangeCommitted={handleChangeCommited}
                valueLabelDisplay="on"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                min={diameterMin}
                max={diameterMax}
                sx={{
                    '& .MuiSlider-thumb': {
                        color: 'green',
                        borderRadius: 0,
                        height: '15px',
                        width: '5px',
                    },
                    '& .MuiSlider-valueLabel': {
                        padding: '3px 5px 0px 5px',
                        fontSize: '11px',
                    },
                    '& .MuiSlider-track': {
                        color: '#821818',
                    },
                    '& .MuiSlider-thumb.Mui-focusVisible , .MuiSlider-thumb:hover': {
                        boxShadow: 'none !important',
                    },
                    '& .MuiSlider-rail': {
                        color: '#821818',
                    },
                    '& .MuiSlider-active': {
                        color: '#821818',
                    },
                    '& .MuiSlider-thumb[data-index="1"]': {
                        color: '#821818',
                        '& .MuiSlider-valueLabel': {
                            top: '-13px',
                            rotate: '180deg',
                        },
                        '& .MuiSlider-valueLabelCircle': {
                            rotate: '180deg',
                            padding: '2px 5px 0px 5px!important',
                            height: '16px',
                        },
                    },
                }}
            />
        </Box>
    );
};
export default DiameterFilterSlider;
